import { ActionTree } from 'vuex';
import { RootState, SystemOrganTypes } from '@/store/types';

export const globalActions: ActionTree<RootState, RootState> = {};
